/**
 * Branch API constants — split bundle (see adjacent files).
 * Do not change endpoint paths without backend alignment.
 */

export const branchSettingsConstants = {
  SETTINGS: {
    GET: (orgSlug: string, branchSlug: string) => `/orgs/${orgSlug}/${branchSlug}/settings`,
    UPDATE: (orgSlug: string, branchSlug: string) => `/orgs/${orgSlug}/${branchSlug}/settings`,
    CATEGORIES: (orgSlug: string, branchSlug: string) => `/orgs/${orgSlug}/${branchSlug}/settings/categories`,
    /** Platform template picks for PDFs (invoice, receipt, report card) */
    DOCUMENT_TEMPLATES: (orgSlug: string, branchSlug: string) =>
      `/orgs/${orgSlug}/${branchSlug}/settings/document-templates`,
  },
  /** Current user's settings (branch context); userId from token */
  USER_SETTINGS: {
    GET: (orgSlug: string, branchSlug: string) => `/orgs/${orgSlug}/${branchSlug}/users/settings`,
    UPDATE: (orgSlug: string, branchSlug: string) => `/orgs/${orgSlug}/${branchSlug}/users/settings`,
  },
  THEMES: {
    LIST: (orgSlug: string, branchSlug: string) => `/orgs/${orgSlug}/branches/${branchSlug}/themes`,
    STATS: (orgSlug: string, branchSlug: string) => `/orgs/${orgSlug}/branches/${branchSlug}/themes/stats`,
    GET_BY_ID: (orgSlug: string, branchSlug: string, id: string) => `/orgs/${orgSlug}/branches/${branchSlug}/themes/${id}`,
    GET_CURRENT: (orgSlug: string, branchSlug: string) => `/orgs/${orgSlug}/branches/${branchSlug}/themes/current`,
    CREATE: (orgSlug: string, branchSlug: string) => `/orgs/${orgSlug}/branches/${branchSlug}/themes`,
    UPDATE: (orgSlug: string, branchSlug: string, id: string) => `/orgs/${orgSlug}/branches/${branchSlug}/themes/${id}`,
    DELETE: (orgSlug: string, branchSlug: string, id: string) => `/orgs/${orgSlug}/branches/${branchSlug}/themes/${id}`,
    SET_DEFAULT: (orgSlug: string, branchSlug: string, id: string) => `/orgs/${orgSlug}/branches/${branchSlug}/themes/${id}/set-default`,
  },
  FONT_SIZES: {
    LIST: (orgSlug: string, branchSlug: string) => `/orgs/${orgSlug}/branches/${branchSlug}/font-sizes`,
    STATS: (orgSlug: string, branchSlug: string) => `/orgs/${orgSlug}/branches/${branchSlug}/font-sizes/stats`,
    GET_BY_ID: (orgSlug: string, branchSlug: string, fontSizeId: string) => `/orgs/${orgSlug}/branches/${branchSlug}/font-sizes/${fontSizeId}`,
    GET_CURRENT: (orgSlug: string, branchSlug: string) => `/orgs/${orgSlug}/branches/${branchSlug}/font-sizes/current`,
    CREATE: (orgSlug: string, branchSlug: string) => `/orgs/${orgSlug}/branches/${branchSlug}/font-sizes`,
    UPDATE: (orgSlug: string, branchSlug: string, fontSizeId: string) => `/orgs/${orgSlug}/branches/${branchSlug}/font-sizes/${fontSizeId}`,
    DELETE: (orgSlug: string, branchSlug: string, fontSizeId: string) => `/orgs/${orgSlug}/branches/${branchSlug}/font-sizes/${fontSizeId}`,
    SET_DEFAULT: (orgSlug: string, branchSlug: string, fontSizeId: string) => `/orgs/${orgSlug}/branches/${branchSlug}/font-sizes/${fontSizeId}/set-default`,
  },
  PROFILE_FORM_CONFIG: (userType: string) =>
    `/branch/profile-form-config?userType=${encodeURIComponent(userType)}`,
  FORM_MANAGEMENT: {
    LIST: () => `/branch/form-management/configs`,
    GET_BY_ID: (formConfigId: string) => `/branch/form-management/configs/${formConfigId}`,
    CREATE: () => `/branch/form-management/configs`,
    UPDATE: (formConfigId: string) => `/branch/form-management/configs/${formConfigId}`,
    DELETE: (formConfigId: string) => `/branch/form-management/configs/${formConfigId}`,
    COPY: (formConfigId: string) => `/branch/form-management/configs/${formConfigId}/copy`,
    PLATFORM_TEMPLATES: () => `/branch/form-management/platform-templates`,
  },
}
